import { FileText, Check, Copy, Eye } from 'lucide-react';

import { Button } from '@/components/ui/Button';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/Card';
import { Textarea } from '@/components/ui/Textarea';
import { RenderPromptResponse } from '@/services/PromptsService';

interface PreviewPromptProps {
  previewPrompt: RenderPromptResponse;
  onCopy: () => void;
  copied: boolean;
}

export function PromptPreviewCard({
  previewPrompt,
  onCopy: handleCopyPreview,
  copied,
}: PreviewPromptProps) {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0">
        <CardTitle className="text-md flex items-center gap-2">
          <FileText className="h-4 w-4" />
          Prompt Preview
        </CardTitle>
        <Button
          variant="outline"
          size="sm"
          onClick={handleCopyPreview}
          className="gap-2 bg-transparent"
          disabled={!previewPrompt?.renderedTemplate}
        >
          {copied ? (
            <Check className="h-4 w-4" />
          ) : (
            <Copy className="h-4 w-4" />
          )}
          {copied ? 'Copied!' : 'Copy'}
        </Button>
      </CardHeader>
      <CardContent>
        {previewPrompt?.renderedTemplate ? (
          <Textarea
            className="min-h-[300px] whitespace-pre-wrap rounded-lg border border-blue-200 bg-gradient-to-br from-blue-50 to-indigo-50 p-6"
            value={previewPrompt.renderedTemplate}
            readOnly
          />
        ) : (
          <div className="py-12 text-center text-muted-foreground">
            <Eye className="mx-auto mb-4 h-16 w-16 opacity-50" />
            <p className="mb-2 text-lg font-medium">No prompt preview yet</p>
            <p className="mb-4 text-sm">
              Generate a preview to see your prompt with parameters
            </p>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
